$shm_ba_chart_timeseries $mol_view
	rows /
	title \Сообщений
	group? \day
	group_options *
	period_pick? null
	period_range_pick? null
	overlay_rows /
	overlay_title \Wordstat
	overlay_series /
	tools_left /
	sub /
		<= Left_tools $mol_view
			style *
				left <= plot_left_style \8px
			sub <= tools_left /
		<= Tools $mol_view
			sub /
				<= Group_select $mol_select
					Filter null
					value? <=> group? \day
					dictionary <= group_options
		<= Chart $shm_echarts
			option <= option null
			brush_cursor <= brush_cursor null
			click? <=> bar_click? null
			brush_end? <=> brush_end? null
			finished? <=> chart_finished? null
